<template>
  <div class="main-list-wrapper" id="template-list-wrapper">
    <div class="headings">
      <div class="main-headings">
        <div class="heading heading-user" @click="onToggleSort('sortingName')">
          <h3>{{ $t("template.tp-list-top-name") }}</h3>
          <div v-if="sortKey === 'sortingName'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
        <div class="heading heading-status" @click="onToggleSort('created')">
          <h3>{{ $t("template.tp-list-top-created") }}</h3>
          <div v-if="sortKey === 'created'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
        <div class="heading heading-status" @click="onToggleSort('lastEdit')">
          <h3>{{ $t("template.tp-list-top-updated") }}</h3>
          <div v-if="sortKey === 'lastEdit'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
        <div class="heading heading-status" @click="onToggleSort('publishSorting')">
          <h3>{{ $t("template.tp-list-top-status") }}</h3>
          <div v-if="sortKey === 'publishSorting'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <ul class="list-wrapper">
      <li
        v-for="template in sortedTemplates"
        :key="template.id"
        class="list-item"
        @click="$emit('template-selected', template)"
        data-cy="template-item"
      >
        <div class="info-cell main-info">
          <div class="template-name">{{ template.name }}</div>
          <div class="text-muted ">
            {{ template.contentType.name }} &nbsp;I&nbsp;
            {{ language(template) }}
          </div>
        </div>

        <div class="info-cell created-info">
          <span class="date"> {{ new Date(template.created) | dateFormat("DD.MM.YYYY - HH:mm") }}</span>
          <span class="text-muted name">{{ template.createdBy.name }}</span>
        </div>
        <div class="info-cell ">
          <div v-if="template.lastEdit" class="updated-info">
            <span class="date"> {{ new Date(template.lastEdit) | dateFormat("DD.MM.YYYY - HH:mm") }}</span>
            <span class="text-muted name">{{ template.lastEditBy.name }}</span>
          </div>
          <div v-else class="updated-info">
            <span class="text-muted name">No edits</span>
          </div>
        </div>

        <div class="info-cell status-info">
          <span>
            {{
              publications.find((p) => p.publishedFromId == template.id)
                ? $t("template.published")
                : $t("template.draft")
            }}
          </span>
        </div>
      </li>
    </ul>

    <div v-if="templates.length == 0" class="no-templates-found ">
      <span>{{ $t("template.tp-list-empty") }} - </span>
      <a target="_blank" href="https://help.icrobotics.com/getting-started">{{ $t("template.guide-link") }}</a>
      <br />
      <span>{{ $t("template.tp-list-empty-1") }}</span>
      <br />
      <button class="btn btn-primary-outline" @click="$emit('add-template')">
        <i class="fa-light fa-plus"></i>
        {{ $t("home.add-template-btn") }}
      </button>
    </div>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";
export default {
  data() {
    return {
      sortKey: "sortingName",
      descending: false
    };
  },
  props: {
    templates: Array,
    publications: Array
  },
  methods: {
    onToggleSort(sortKey) {
      this.descending = this.sortKey == sortKey ? !this.descending : false;
      this.sortKey = sortKey;
    },
    language(template) {
      const lang = this.$store.state.templateLanguages.find((l) => l.value == template.language.toLowerCase());
      return lang ? this.$t(lang.name) : "";
    }
  },
  computed: {
    sortedTemplates: function() {
      let templateList = this.templates.map((obj) => {
        const nameObj = JSON.stringify(obj.name);
        const lowCase = nameObj.toLowerCase();
        const publishSorting = this.publications.find((p) => p.publishedFromId == obj.id) ? "a" : "b";
        obj.sortingName = lowCase;
        obj.publishSorting = publishSorting;
      });

      return orderBy(this.templates || [], (template) => template[this.sortKey], [this.descending ? "desc" : "asc"]);
      // return _.orderBy(this.templates, this.sortKey)
    }
    //   sortedTemplates () {
    //       return _.orderBy(this.templates || [], template => template[this.sortKey].toString().toLowerCase(), [this.descending ? 'desc' : 'asc'])
    //     }
  }
};
</script>

<style lang="less">
#app #template-list-wrapper {
  .headings {
    display: none;
  }
  .list-wrapper {
    width: 100%;
    list-style-type: none;
    padding: 0;
    .list-item {
      padding: 8px 20px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;

      &:hover {
        background-color: rgba(188, 193, 195, 0.2);
      }
    }
    .template-name {
      font-weight: 500;
      font-size: 14px;
    }
    .info-cell {
      font-size: 12px;
    }

    .created-info,
    .updated-info {
      display: none;

      .date {
        font-size: 12px;
        font-weight: 400;
      }
      .name {
        // font-size: 10px;
      }
    }
  }

  .no-templates-found {
    text-align: center;
    line-height: 25px;
    padding-top: 30px;
    button {
      margin: 0 auto;
    }
  }
}

@media screen and (min-width: 768px) {
  #app #template-list-wrapper {
    .headings {
      display: flex;
      flex-grow: 1;
      border-bottom: 1px solid var(--charcoal-20);
      padding: 14px 20px;
    }
    .main-headings {
      flex-grow: 1;
      display: grid;
      grid-template-columns: 3fr 2fr 2fr 1fr;
    }

    .heading {
      cursor: pointer;
      display: flex;
      gap: 8px;
      align-items: center;
      h3 {
        color: var(--charcoal-75);
        margin-bottom: 0;
      }
    }

    .list-wrapper {
      .list-item {
        flex-grow: 1;
        display: grid;
        grid-template-columns: 3fr 2fr 2fr 1fr;
        .created-info,
        .updated-info {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
      }
    }
  }
}
</style>
